import { Routes, Route } from 'react-router-dom';
import './App.css';
import Home from './Pages/Home';
import Dashboard from './Pages/Dashboard';
import Login from './Pages/Login';
import { RequireAuth, useAuthUser } from 'react-auth-kit';
import User from "../src/Models/User";
import GestionQm from './Pages/EspaceQm';
import LiveScreem from './Components/Qm/LiveScreem';
import LiveScreenPro from './Components/Qm/LiveScreenPro';
import Setting from './Pages/Setting';
import Pub from './Pages/Pub';
import GenerationTicket from './Components/Qm/GenerationTicket';
import GestionTickets from './Pages/GestionTickets';
import OTP from './Pages/OTP';
import NotFound from './Pages/NotFound';
import CheckInPage from './Pages/CheckInPage';
import Demandes from './Pages/Demandes';
import Stat from './Pages/Stat';
import SelfService from './Pages/SelfService';
import LiveScreemEcran from './Ecran/LiveScreemEcran';

function App() {

  return (
    <div className="App">
      <Routes>
        <Route path="/gestion/*" element={
          <RequireAuth loginPath={'/login'}>
            <Home />
          </RequireAuth>
        } />

        <Route path="/" element={
          <RequireAuth loginPath={'/login'}>
            <Dashboard />
          </RequireAuth>
        } />


        <Route path="/Qm" element={
          <RequireAuth loginPath={'/login'}>
            <GestionQm />
          </RequireAuth>
        } />

        {/* <Route path="/liveScreem" element={
          <RequireAuth loginPath={'/login'}>
            <LiveScreem />
          </RequireAuth>
        } /> */}

        {/* Application TV autonome — enrôlement par code, aucun login.
            DOIT rester AVANT /liveScreem : le matching est insensible à la casse. */}
        <Route path="/livescreem" element={<LiveScreemEcran />} />
        <Route path="/livescreem/:code" element={<LiveScreemEcran />} />

        <Route path="/liveScreem" element={
          <RequireAuth loginPath={'/login'}>
            <LiveScreenPro />
          </RequireAuth>
        } />


        <Route path="/setting/*" element={
          <RequireAuth loginPath={'/login'}>
            <Setting />
          </RequireAuth>
        } />

        <Route path="/gestionTicket" element={
          <RequireAuth loginPath={'/login'}>
            <GestionTickets />
          </RequireAuth>
        } />

        <Route path="/pub" element={
          <RequireAuth loginPath={'/login'}>
            <Pub />
          </RequireAuth>
        } />

        <Route path="/checkin" element={
          <RequireAuth loginPath={'/login'}>
            <CheckInPage />
          </RequireAuth>
        } />

        <Route path="/demandes" element={
          <RequireAuth loginPath={'/login'}>
            <Demandes />
          </RequireAuth>
        } />

        <Route path="/Stat" element={
          <RequireAuth loginPath={'/login'}>
            <Stat />
          </RequireAuth>
        } />

        <Route path="/login" element={<Login />} />
        <Route path="/self-service" element={<SelfService />} />
        <Route path="/OTP_Verification" element={<OTP />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </div>

  );
}

export default App;
